/**
 * RegistroCompra Constants
 * Valores por defecto y constantes
 */


// Catálogos para formularios de Registro de Compra
export const MONEDAS = ['Dólares', 'Soles'] as const;

export const TIPOS_DOCUMENTO = [
  '00 - OTROS',
  '01 - FACTURA',
  '02 - RECIBO POR HONORARIOS',
  '03 - BOLETA DE VENTA',
  '05 - BOLETO AEREO',
  '07 - NOTA DE CREDITO',
  '08 - NOTA DE DEBITO',
  '10 - RECIBO POR ARRENDAMIENTO',
  '12 - TICKETS',
  '13 - DOCUMENTO EMITIDO POR BANCOS',
  '14 - RECIBO SERVICIOS PUBLICOS',
  '15 - BOLETO TRANSPORTE PUBLICO URBANO',
  '20 - COMPROBANTE DE RETENCION',
  '30 - DOCUMENTOS EMITIDOS POR EMPRESAS TARJETA DE CREDITO Y DEBITO',
  '50 - DECLARACION UNICA DE ADUANAS',
  '91 - COMPROBANTE DE NO DOMICILIADO',
] as const;

export const CODIGOS_DETRACCION = [
  '027 - RETIRO DE SERVICIOS DE TRANSPORTE DE BIENES - 4.00',
  '024 - COMISIÓN MERCANTIL - 10.00',
  '026 - TRANSPORTE DE PERSONAS - 10.00',
  '019 - ARRENDAMIENTO DE BIENES - 10.00',
  '020 - REPARACIÓN DE BIENES MUEBLES - 12.00',
  '037 - DEMÁS SERVICIOS GRAVADOS CON IGV - 12.00',
  '022 - OTROS SERVICIOS EMPRESARIALES - 12.00',
] as const;

export const CUENTAS_CONTABLES = [
  '10001 - B2B Ventas de Agencias',
  '11001 - B2C Ventas Web y Directos',
  '12001 - Ventas Huaraz',
  '17001 - Ingresos por subarrendamiento',
  '17002 - Ingresos por enajenación de Propiedad, Planta y Equipo',
  '17003 - Otros Ingresos',
  '20001 - B2B Costos directos de operación de files Agencias',
  '21001 - B2C Costos directos de operación de files Ventas Web y Directos',
  '22001 - Huaraz Costos directos de operación de files vendidos por Oficina Huaraz',
  '24001 - Costo de planilla Ventas B2B',
  '24002 - Costos de Transacción B2B',
  '24003 - Costos Licencias CRM',
  '25001 - Costo de planilla Ventas B2C',
  '25002 - Costos de Transacción B2C',
  '25003 - Costos Licencias CRM',
  '26001 - Costos de Transacción Ventas Huaraz',
  '27001 - Planilla Aventura',
  '27002 - Comunicación - Telefonia Satelital y GPS (Equipos y suscripciones)',
  '27003 - Insumos para Botiquines & Oxigeno',
  '27004 - MTB Equipos (Activos Menores)',
  '27005 - MTB Servicios relacionados',
  '27006 - Trek - Uniformes & Equipo para Personal de Campo',
  '27007 - Trek - Servicios relacionados a Aventura',
  '27008 - Trek - Equipos de Trekking (Activos Menores)',
  '27009 - Trek - Insumos',
  '27010 - Trek - Alquiler & Mantenimiento de Propiedades arrendadas CHAMANA',
  '27011 - Trek - Alquiler & Mantenimiento de Propiedades arrendadas CAMICANCHA',
  '28001 - Planillas Servicio al cliente',
  '28002 - Taxis y Movilidades',
  '28003 - Cortesías y compensaciones a Clientes',
  '29001 - Planilla Alimentos & Bebidas',
  '29002 - Abarrotes',
  '29003 - Alimentos Perecibles',
  '29005 - Abarrotes y cocina - Equipos (Activos Menores)',
  '29006 - Abarrotes y cocina - Servicios relacionados',
  '30001 - Costos Laborales Camion',
  '30002 - Petroleo',
  '30003 - Mantenimiento, Repuestos y Reparaciones',
  '30004 - Seguros',
  '30005 - Otros Gastos relacionados al Camion',
  '31001 - Capacitacion Guias / CUSCO',
  '31002 - Capacitacion Cocineros / CUSCO',
  '31003 - Capacitacion Guias Bike / CUSCO',
  '31004 - Capacitacion Porteadores / CUSCO',
  '31005 - Capacitacion Arrieros & Vacunacion Asemilas / CUSCO',
  '31006 - Capacitacion Guias y Cocineros / HUARAZ',
  '31007 - Capacitacion Guias y Cocineros / PUNO',
  '32001 - Chocolatada fin de año & Campeonato fútbol porteadores',
  '32002 - Apoyo a comunidades',
  '32003 - Apoyo campañas limpieza - Camino Inca',
  '32004 - Otros apoyos en campaña de limpieza (Ej. Urubamba, Piuray, etc.)',
  '33001 - Uniformes Personal de Campo, Cocineros, Guías & Trasladistas',
  '33002 - Otros costos indirectos',
  '40001 - Costos de Personal (Administrativos y gerencia)',
  '40002 - Atenciones y Beneficios al personal',
  '40003 - Capacitación al Personal',
  '40004 - Otros Costos de Personal',
  '41001 - Gastos de Comunicación',
  '41002 - Gastos de Viajes Nacionales Funcionarios',
  '41003 - Gastos de Representacion',
  '42001 - Licencias Software',
  '42002 - Mantenimiento de Equipos de Cómputo',
  '42003 - Activos menores - Cómputo',
  '43001 - Alquileres',
  '43002 - Servicios Básicos',
  '43003 - Imprenta y utilidades de oficina',
  '43004 - Mantenimiento de oficinas',
  '43005 - Mejoras en Infraestructura',
  '43006 - Utiles de limpieza',
  '43007 - Gastos municipales (ARBITRIOS Y LICENCIAS)',
  '44001 - Servicios de Contabilidad',
  '44002 - Servicios Legales',
  '44003 - Asesorías empresariales',
  '44004 - Seguros',
  '44005 - Cuotas de asociado',
  '44006 - Certificaciones',
  '45001 - Comisiones bancarias',
  '45002 - Activos varios - Bienes menores - ACTIVOS FIJOS',
  '50001 - DEPRECIACION EQUIPOS TREK Y MENAJERÍA',
  '50002 - DEPRECIACION VEHÍCULO MOTORIZADOS - LEASING',
  '50003 - DEPRECIACION EQUIP. PARA PROC. DE INF.',
  '50004 - DEPRECIACION EQUIPOS DE CÓMPUTO - LEASING',
  '50005 - DEPRECIACION EQUIP. DE COMUNICACIÓN',
  '50006 - DEPRECIACION EDIFICAC. ADMINISTRATIVAS',
  '50007 - DEPRECIACION VEHÍCULOS MENORES NO MOTORIZADOS',
  '50008 - DEPRECIACION MUEBLES Y ENSERES',
  '50009 - DEPRECIACION EQUIP. DE SEGURIDAD',
  '50010 - DEPRECIACION VEHÍCULOS MENORES MOTORIZADOS',
  '60001 - CANAL B2B',
  '60002 - CANAL B2C',
  '60003 - DESARROLLO DE PRODUCTOS & CONTENIDO',
  '60004 - OTROS COSTOS DE MARKETING',
  '70001 - Imprevistos',
  '75001 - Servicios Legales de ejercicios anteriores',
  '75002 - Servicios Contables de ejercicios anteriores',
  '75003 - Costo de planilla de ejercicios anteriores',
  '75004 - Costos directos de ejercicios anteriores',
  '90001 - Intereses por operaciones financieras',
  '91001 - Impuesto a la Renta',
  '91002 - Impuesto a la Renta por Reparos Tributarios',
  '91003 - ITAN',
  '91004 - Otros Impuestos',
] as const;
